import { render, staticRenderFns } from "./PageService.vue?vue&type=template&id=4824aea1&"
import script from "./PageService.vue?vue&type=script&lang=js&"
export * from "./PageService.vue?vue&type=script&lang=js&"
import style0 from "./PageService.vue?vue&type=style&index=0&id=4824aea1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports